export enum FormIds
{
  LOGIN     = 'login',
  PWD       = 'pwd',
  MFA_SETUP = 'mfaSetup',
  MFA       = 'mfa'
}
